import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import adminApi, { errMsg } from '../api';
import { useAdminAuth } from '../auth';

export default function Login() {
  const [step, setStep] = useState('phone'); // 'phone' | 'code'
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { refresh } = useAdminAuth();

  const sendCode = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.post('/auth/login/start', { phone });
      setStep('code');
      toast.success('Code sent');
    } catch (err) {
      toast.error(errMsg(err, 'Could not send code'));
    } finally {
      setBusy(false);
    }
  };

  const verify = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await adminApi.post('/auth/login/verify', { phone, code });
      localStorage.setItem('admin_mahi_token', data.token);
      await refresh();
      navigate('/', { replace: true });
    } catch (err) {
      toast.error(errMsg(err, 'Invalid code'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-page px-4">
      <div className="w-full max-w-sm rounded-2xl border border-hairline bg-surface p-8 shadow-sm">
        <div className="mb-6">
          <span className="text-lg font-semibold text-ink">
            admin<span className="text-raspberry-600">.mahi</span>
          </span>
          <p className="mt-1.5 text-sm text-ink-secondary">
            Staff sign-in - your phone number must already be registered by an owner.
          </p>
        </div>

        {step === 'phone' ? (
          <form onSubmit={sendCode} className="space-y-4">
            <label className="block text-sm font-medium text-ink-secondary">
              Phone number
              <input
                type="tel"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="9876543210"
                className="mt-1 w-full rounded-lg border border-hairline px-3 py-2 text-sm text-ink focus:outline-none focus:ring-2 focus:ring-raspberry-300"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              className="w-full rounded-lg bg-raspberry-600 py-2 text-sm font-medium text-white transition-colors hover:bg-raspberry-700 disabled:opacity-50"
            >
              {busy ? 'Sending…' : 'Send code'}
            </button>
          </form>
        ) : (
          <form onSubmit={verify} className="space-y-4">
            <label className="block text-sm font-medium text-ink-secondary">
              Code sent to {phone}
              <input
                type="text"
                inputMode="numeric"
                required
                autoFocus
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="000000"
                className="mt-1 w-full rounded-lg border border-hairline px-3 py-2 text-sm tracking-widest text-ink focus:outline-none focus:ring-2 focus:ring-raspberry-300"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              className="w-full rounded-lg bg-raspberry-600 py-2 text-sm font-medium text-white transition-colors hover:bg-raspberry-700 disabled:opacity-50"
            >
              {busy ? 'Verifying…' : 'Sign in'}
            </button>
            <button
              type="button"
              onClick={() => setStep('phone')}
              className="w-full text-xs text-ink-muted hover:text-ink-secondary"
            >
              Use a different number
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
